import React from "react";
import { DoubleFigure } from "../Figure";
import { CloClo } from "../Abbrevs";
export const tabs = [
    {
        year: 2024,
        cssname: "july22",
        node: <>
             <h1>Field</h1>
            <p>Found isopod without clear identification.</p>
            <DoubleFigure
            url1="https://i.ibb.co/CWPTt1d/venlo-isopod-lateral.jpg"
            caption1="Lateral view"
            alt1="venlo-isopod-lateral"
            url2="https://i.ibb.co/GWmjP4v/venlo-isopod-dorsal.jpg"
            caption2="Dorsal view"
            alt2="venlo-isopod-dorsal"
            />
            <p>{CloClo} suggested it could be A. archangelii</p>
            <p>I took further photos for identification which have to be analysed yet.</p>
        </>
    },
    {
        year: 2024,
        cssname: "july23",
        node: <>
             <h1>Website</h1>
            <ul>
                <li>moved website to use a framework instead of WordPress</li>
                <li>Added 8 further guides</li>
            </ul>
        </>
    },
    {
        year: 2024,
        cssname: "july26",
        node: <>
             <h1>Website</h1>
            <ul>
                <li>Added lung article from former website</li>
            </ul>
        </>
    },
    {
        year: 2024,
        cssname: "august3",
        node: <>
             <h1>Website</h1>
            <ul>
                <li>Added many pages (e.g. Education, Care, ...)</li>
            </ul>
        </>
    },
    {
        year: 2024,
        cssname: "august28",
        node: <>
             <h1>Website</h1>
            <ul>
                <li>Added social media embeds </li>
            </ul>
        </>
    },
    {
        year: 2024,
        cssname: "august28",
        node: <>
             <h1>Website</h1>
            <ul>
                <li>Added artist profile from former page </li>
            </ul>
        </>
    },
    {
        year: 2024,
        cssname: "october6",
        node: <>
             <h1>Website</h1>
            <ul>
                <li>Added calendar</li>
                <li>Fixed issues to make already existing pages visible</li>
                <li>Added calendar entries going back a few months</li>
            </ul>
        </>
    },
    // Add more entries as needed...
];
